import AbstractFormField, {AbstractFormFieldProperties} from "./AbstractFormField";
import {CSSProperties, ReactNode} from "react";
import {BorderStyle, Field} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {PortalAnnotation} from "../../../../shared/models/PortalAnnotation";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";
import {ListBoxProps} from "primereact/listbox";
import ListInput, {ListOption} from "../../../../shared/components/ListInput";

interface ListboxFieldProperties extends AbstractFormFieldProperties, ListBoxProps {
	onValue: (values: Array<string>) => void;
}

export class ListboxField extends AbstractFormField<ListboxFieldProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let field: Field = Field.fromJson(this.props.field.get());

		let options: Array<ListOption> = [];
		for (let value of FunctionHelper.applyValue(field.value, Field.getValueDefault())) {
			options.push({
				label: value.display,
				value: value._export
			})
		}

		let value: Array<string> = [];
		if (FunctionHelper.exists(this.props.value) && Array.isArray(this.props.value) && this.props.value.length > 0) {
			for (let val of this.props.value) {
				value.push(val);
			}
		}

		let fieldElements: Array<ReactNode> = [];
		for (let annotation of FunctionHelper.applyValue(field.annotation, Field.getAnnotationDefault())) {
			if (!this.shouldRenderAnnotation(annotation)) {
				continue;
			}

			let portalAnnotation: PortalAnnotation = PortalAnnotation.fromJson(
				FunctionHelper.applyValue(annotation, Field.getAnnotationDefault())
			);

			let fieldStyle: CSSProperties = {
				...this.computeFieldsStyle(portalAnnotation),
				...this.props.style
			};

			if (FunctionHelper.exists(portalAnnotation.border)) {
				fieldStyle.borderColor = portalAnnotation.border!.interiorColor;
				fieldStyle.borderWidth = portalAnnotation.border!.width!.toString();

				if (portalAnnotation.border!.style === BorderStyle.Dashed) {
					fieldStyle.borderStyle = "dashed";
				}
			}

			fieldElements.push(
				<ListInput className={"field " + field.subType!.toLowerCase() + "-field"} style={fieldStyle}
						   key={field.objectKey + " " + portalAnnotation.objectKey} options={options}
						   multiple={field.multiSelect} value={value} disabled={this.props.disabled}
						   tabIndex={this.getTabIndex(annotation.objectKey)}
						   onChange={(event) => {
							   this.props.onValue(FunctionHelper.applyValue(event.value, []));
						   }}/>
			);
		}

		return fieldElements;
	}
}